"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RecordingEventType;
(function (RecordingEventType) {
    RecordingEventType[RecordingEventType["MutationInsert"] = 1] = "MutationInsert";
    RecordingEventType[RecordingEventType["MutationRemove"] = 2] = "MutationRemove";
    RecordingEventType[RecordingEventType["MutationAttribute"] = 3] = "MutationAttribute";
    RecordingEventType[RecordingEventType["MutationCharacterData"] = 4] = "MutationCharacterData";
    RecordingEventType[RecordingEventType["InitialDom"] = 5] = "InitialDom";
    RecordingEventType[RecordingEventType["Scroll"] = 6] = "Scroll";
    RecordingEventType[RecordingEventType["MouseMove"] = 7] = "MouseMove";
    RecordingEventType[RecordingEventType["Click"] = 8] = "Click";
    RecordingEventType[RecordingEventType["Resize"] = 9] = "Resize";
    RecordingEventType[RecordingEventType["InputCheckable"] = 10] = "InputCheckable";
    RecordingEventType[RecordingEventType["InputSelect"] = 11] = "InputSelect";
    RecordingEventType[RecordingEventType["InputText"] = 12] = "InputText";
    RecordingEventType[RecordingEventType["HashChange"] = 13] = "HashChange";
    RecordingEventType[RecordingEventType["ConsentGranted"] = 14] = "ConsentGranted";
    RecordingEventType[RecordingEventType["ConsentWithdrawn"] = 15] = "ConsentWithdrawn";
    RecordingEventType[RecordingEventType["MouseOver"] = 16] = "MouseOver";
    RecordingEventType[RecordingEventType["VisibilityChange"] = 17] = "VisibilityChange";
    RecordingEventType[RecordingEventType["StylesheetRuleInsert"] = 18] = "StylesheetRuleInsert";
})(RecordingEventType = exports.RecordingEventType || (exports.RecordingEventType = {}));
//# sourceMappingURL=recording-event-type.js.map